
/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  MisclassificationGuidelineResource,
} from '../models';
import {
    MisclassificationGuidelineResourceFromJSON,
    MisclassificationGuidelineResourceToJSON,
} from '../models';

export interface ConfirmMisclassificationGuidelineReviewRequest {
    organizationId: string;
    misclassificationGuidelineId: string;
}

export interface CreateMisclassificationGuidelineRequest {
    organizationId: string;
    file: Blob;
    countryCodes: Set<string>;
}

export interface DeleteMisclassificationGuidelineRequest {
    organizationId: string;
    misclassificationGuidelineId: string;
}

export interface GetMisclassificationGuidelineRequest {
    organizationId: string;
    misclassificationGuidelineId: string;
}

export interface GetMisclassificationGuidelinesWritePermissionsRequest {
    organizationId: string;
}

export interface ListMisclassificationGuidelinesRequest {
    organizationId: string;
}

export interface UpdateMisclassificationGuidelineRequest {
    organizationId: string;
    misclassificationGuidelineId: string;
    countryCodes: Set<string>;
    file?: Blob | null;
}

/**
 * 
 */
export class MisclassificationGuidelinesApi extends runtime.BaseAPI {

    /**
     * Confirm that the current hiring manager has reviewed the misclassification guideline
          */
    async confirmMisclassificationGuidelineReviewRaw(requestParameters: ConfirmMisclassificationGuidelineReviewRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling confirmMisclassificationGuidelineReview().'
            );
        }

        if (requestParameters['misclassificationGuidelineId'] == null) {
            throw new runtime.RequiredError(
                'misclassificationGuidelineId',
                'Required parameter "misclassificationGuidelineId" was null or undefined when calling confirmMisclassificationGuidelineReview().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<void>({
            path: `/compliance/api/organizations/{organizationId}/misclassification/guidelines/{misclassificationGuidelineId}/reviews`.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters['organizationId']))).replace(`{${"misclassificationGuidelineId"}}`, encodeURIComponent(String(requestParameters['misclassificationGuidelineId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return response;
    }

    /**
     * Confirm that the current hiring manager has reviewed the misclassification guideline
          */
    async confirmMisclassificationGuidelineReview(requestParameters: ConfirmMisclassificationGuidelineReviewRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.confirmMisclassificationGuidelineReviewRaw(requestParameters, initOverrides);
    }

    /**
     * Create a misclassification guideline
          */
    async createMisclassificationGuidelineRaw(requestParameters: CreateMisclassificationGuidelineRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<MisclassificationGuidelineResource>> {
        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling createMisclassificationGuideline().'
            );
        }

        if (requestParameters['file'] == null) {
            throw new runtime.RequiredError(
                'file',
                'Required parameter "file" was null or undefined when calling createMisclassificationGuideline().'
            );
        }

        if (requestParameters['countryCodes'] == null) {
            throw new runtime.RequiredError(
                'countryCodes',
                'Required parameter "countryCodes" was null or undefined when calling createMisclassificationGuideline().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['file'] != null) {
            formParams.append('file', requestParameters['file'] as any);
        }

        if (requestParameters['countryCodes'] != null) {
            formParams.append('countryCodes', Array.from(requestParameters['countryCodes'])!.join(runtime.COLLECTION_FORMATS["csv"]));
        }

        const response = await this.request<MisclassificationGuidelineResource>({
            path: `/compliance/api/organizations/{organizationId}/misclassification/guidelines`.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters['organizationId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        if (response._data) { response._data=MisclassificationGuidelineResourceFromJSON(response._data); }
        return response;
    }

    /**
     * Create a misclassification guideline
          */
    async createMisclassificationGuideline(requestParameters: CreateMisclassificationGuidelineRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<MisclassificationGuidelineResource> {
        const response = await this.createMisclassificationGuidelineRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Delete a misclassification guideline by ID
          */
    async deleteMisclassificationGuidelineRaw(requestParameters: DeleteMisclassificationGuidelineRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling deleteMisclassificationGuideline().'
            );
        }

        if (requestParameters['misclassificationGuidelineId'] == null) {
            throw new runtime.RequiredError(
                'misclassificationGuidelineId',
                'Required parameter "misclassificationGuidelineId" was null or undefined when calling deleteMisclassificationGuideline().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<void>({
            path: `/compliance/api/organizations/{organizationId}/misclassification/guidelines/{misclassificationGuidelineId}`.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters['organizationId']))).replace(`{${"misclassificationGuidelineId"}}`, encodeURIComponent(String(requestParameters['misclassificationGuidelineId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return response;
    }

    /**
     * Delete a misclassification guideline by ID
          */
    async deleteMisclassificationGuideline(requestParameters: DeleteMisclassificationGuidelineRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteMisclassificationGuidelineRaw(requestParameters, initOverrides);
    }

    /**
     * Get a misclassification guideline by ID
          */
    async getMisclassificationGuidelineRaw(requestParameters: GetMisclassificationGuidelineRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<MisclassificationGuidelineResource>> {
        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling getMisclassificationGuideline().'
            );
        }

        if (requestParameters['misclassificationGuidelineId'] == null) {
            throw new runtime.RequiredError(
                'misclassificationGuidelineId',
                'Required parameter "misclassificationGuidelineId" was null or undefined when calling getMisclassificationGuideline().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<MisclassificationGuidelineResource>({
            path: `/compliance/api/organizations/{organizationId}/misclassification/guidelines/{misclassificationGuidelineId}`.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters['organizationId']))).replace(`{${"misclassificationGuidelineId"}}`, encodeURIComponent(String(requestParameters['misclassificationGuidelineId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=MisclassificationGuidelineResourceFromJSON(response._data); }
        return response;
    }

    /**
     * Get a misclassification guideline by ID
          */
    async getMisclassificationGuideline(requestParameters: GetMisclassificationGuidelineRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<MisclassificationGuidelineResource> {
        const response = await this.getMisclassificationGuidelineRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Check if the current user has write permissions on misclassification guidelines for the given organization
          */
    async getMisclassificationGuidelinesWritePermissionsRaw(requestParameters: GetMisclassificationGuidelinesWritePermissionsRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<boolean>> {
        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling getMisclassificationGuidelinesWritePermissions().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<boolean>({
            path: `/compliance/api/organizations/{organizationId}/misclassification/guidelines/write-permissions`.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters['organizationId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return response;
    }

    /**
     * Check if the current user has write permissions on misclassification guidelines for the given organization
          */
    async getMisclassificationGuidelinesWritePermissions(requestParameters: GetMisclassificationGuidelinesWritePermissionsRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<boolean> {
        const response = await this.getMisclassificationGuidelinesWritePermissionsRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * List misclassification guidelines for the current organization
          */
    async listMisclassificationGuidelinesRaw(requestParameters: ListMisclassificationGuidelinesRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<Array<MisclassificationGuidelineResource>>> {
        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling listMisclassificationGuidelines().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<Array<MisclassificationGuidelineResource>>({
            path: `/compliance/api/organizations/{organizationId}/misclassification/guidelines`.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters['organizationId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        response._data=response._data?.map(MisclassificationGuidelineResourceFromJSON);
        return response;
    }

    /**
     * List misclassification guidelines for the current organization
          */
    async listMisclassificationGuidelines(requestParameters: ListMisclassificationGuidelinesRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<Array<MisclassificationGuidelineResource>> {
        const response = await this.listMisclassificationGuidelinesRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Update a misclassification guideline by ID
          */
    async updateMisclassificationGuidelineRaw(requestParameters: UpdateMisclassificationGuidelineRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling updateMisclassificationGuideline().'
            );
        }

        if (requestParameters['misclassificationGuidelineId'] == null) {
            throw new runtime.RequiredError(
                'misclassificationGuidelineId',
                'Required parameter "misclassificationGuidelineId" was null or undefined when calling updateMisclassificationGuideline().'
            );
        }

        if (requestParameters['countryCodes'] == null) {
            throw new runtime.RequiredError(
                'countryCodes',
                'Required parameter "countryCodes" was null or undefined when calling updateMisclassificationGuideline().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['file'] != null) {
            formParams.append('file', requestParameters['file'] as any);
        }

        if (requestParameters['countryCodes'] != null) {
            formParams.append('countryCodes', Array.from(requestParameters['countryCodes'])!.join(runtime.COLLECTION_FORMATS["csv"]));
        }

        const response = await this.request<void>({
            path: `/compliance/api/organizations/{organizationId}/misclassification/guidelines/{misclassificationGuidelineId}`.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters['organizationId']))).replace(`{${"misclassificationGuidelineId"}}`, encodeURIComponent(String(requestParameters['misclassificationGuidelineId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return response;
    }

    /**
     * Update a misclassification guideline by ID
          */
    async updateMisclassificationGuideline(requestParameters: UpdateMisclassificationGuidelineRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.updateMisclassificationGuidelineRaw(requestParameters, initOverrides);
    }

}
